import PropTypes from 'prop-types';


/**
 * The proptype shape of the via request object.
 * These are stored in the redux state: state.via.domain.requests[requestId]
 */
export const viaRequestShape = PropTypes.shape({
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.arrayOf(PropTypes.string),
  payload: PropTypes.shape({}),
});


/**
 * The currencies that are supported in VIA.
 */
export const CURRENCIES = {
  GBP: {
    symbol: '£', code: 'GBP', flag: 'gb', description: 'British Pound Sterling',
  },
  EUR: {
    symbol: '€', code: 'EUR', flag: 'eu', description: 'Euro',
  },
  USD: {
    symbol: '$', code: 'USD', flag: 'us', description: 'United States Dollar',
  },
};

export function formatMoney(number, currencyCode) {
  return number.toLocaleString(undefined, { style: 'currency', currency: currencyCode });
}

/**
 * Creates an ISO standard date string.
 * @param {Date} date The date to be converted to a string.
 */
export function toIsoString(date) {
  const tzo = -date.getTimezoneOffset();
  const dif = tzo >= 0 ? '+' : '-';
  const pad = (num) => {
    const norm = Math.floor(Math.abs(num));
    return (norm < 10 ? '0' : '') + norm;
  };

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())
  }:${pad(date.getSeconds())
  }${dif}${pad(tzo / 60)
  }:${pad(tzo % 60)}`;
}


let idCounter = 0;

export function uniqueId(prefix = '') {
  const id = prefix + idCounter;
  idCounter += 1;

  return id;
}
